import { render } from "./XPrimary.vue?vue&type=template&id=be9a87d4&scoped=true"
import script from "./XPrimary.vue?vue&type=script&lang=js"
export * from "./XPrimary.vue?vue&type=script&lang=js"

import "./XPrimary.vue?vue&type=style&index=0&id=be9a87d4&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9a87d4"]])

export default __exports__